import { render, staticRenderFns } from "./static-usp.vue?vue&type=template&id=3fcea298&"
import script from "./static-usp.vue?vue&type=script&lang=js&"
export * from "./static-usp.vue?vue&type=script&lang=js&"
import style0 from "./static-usp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports